import e from "react";
import { c as n, t as o } from "./app-a75c1d35.mjs";
import { B as c } from "./Block-9b78bd10.mjs";
import { I as s } from "./Image-d6406817.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
const y = "article-image-gallery", d = "article-image-gallery__one_image-container", p = "desktop", G = "article-gallery-image", I = "article-image-gallery__one_text-container", C = "article-image-gallery__two", E = "article-image-gallery__two--first", T = "article-image-gallery__two--second", w = "article-gallery-credits", N = "article-gallery-caption", a = {
  articleImageGallery: y,
  articleImageGalleryOneImageContainer: d,
  desktop: p,
  articleGalleryImage: G,
  articleImageGalleryOneTextContainer: I,
  articleImageGalleryTwo: C,
  articleImageGalleryTwoFirst: E,
  articleImageGalleryTwoSecond: T,
  articleGalleryCredits: w,
  articleGalleryCaption: N
};
function b({
  creditsLabel: i = "Credits",
  images: r = []
}) {
  if (r.length < 1)
    return null;
  const [l, t] = r;
  return /* @__PURE__ */ e.createElement(
    c,
    {
      topPadding: c.Padding.SMALL,
      bottomPadding: c.Padding.LARGE,
      className: a.articleImageGallery,
      "data-testid": "article-image-gallery-block"
    },
    /* @__PURE__ */ e.createElement(
      c.Content,
      {
        "data-testid": "article-image-gallery-block-content",
        itemScope: !0,
        itemType: "https://schema.org/ImageObject"
      },
      t ? /* @__PURE__ */ e.createElement(
        u,
        {
          creditsLabel: i,
          image: l,
          image2: t,
          "data-testid": "gallery-two-images"
        }
      ) : /* @__PURE__ */ e.createElement(
        _,
        {
          creditsLabel: i,
          image: l,
          "data-testid": "gallery-one-image"
        }
      )
    )
  );
}
function _(i) {
  const { image: r, creditsLabel: l } = i, { caption: t, credits: m, ...g } = r;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: a.articleImageGalleryOneImageContainer }, /* @__PURE__ */ e.createElement(
    s,
    {
      ...g,
      credits: m,
      className: a.articleGalleryImage
    }
  )), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: n(
        o.textsCaption,
        a.articleImageGalleryOneTextContainer
      )
    },
    m && /* @__PURE__ */ e.createElement("p", { className: a.articleGalleryCredits, itemProp: "creditText" }, l, ": ", m),
    t && /* @__PURE__ */ e.createElement("p", { className: a.articleGalleryCaption, itemProp: "caption" }, t)
  ));
}
function u(i) {
  const { creditsLabel: r, image: l, image2: t } = i;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "article-image-gallery-first",
      className: n(
        a.articleImageGalleryTwo,
        a.articleImageGalleryTwoFirst,
        o.textsCaption
      )
    },
    /* @__PURE__ */ e.createElement(
      s,
      {
        ...l,
        className: a.articleGalleryImage,
        "data-testid": "article-image-gallery-image"
      }
    ),
    l.credits && /* @__PURE__ */ e.createElement("p", { className: a.articleGalleryCredits, itemProp: "creditText" }, r, ": ", l.credits),
    l.caption && /* @__PURE__ */ e.createElement("p", { className: a.articleGalleryCaption, itemProp: "caption" }, l.caption)
  ), /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "article-image-gallery-second",
      className: n(
        a.articleImageGalleryTwo,
        a.articleImageGalleryTwoSecond,
        o.textsCaption
      )
    },
    /* @__PURE__ */ e.createElement(
      s,
      {
        ...t,
        className: a.articleGalleryImage,
        "data-testid": "article-image-gallery-image"
      }
    ),
    t.credits && /* @__PURE__ */ e.createElement("p", { className: a.articleGalleryCredits, itemProp: "creditText" }, r, ": ", t.credits),
    t.caption && /* @__PURE__ */ e.createElement("p", { className: a.articleGalleryCaption, itemProp: "caption" }, t.caption)
  ));
}
export {
  b as ArticleImageGallery
};
//# sourceMappingURL=ArticleImageGallery.js.map
